// IL REGISTRO DELLE APP: l'unico posto che sa quali applicazioni esistono.
//
// Da qui nascono il launcher (/hub), il selettore nella barra in alto e il menu di lato. Aggiungere
// un'app vuol dire creare src/apps/<id>/{app.js, menu.js, routes.js} e aggiungerla agli elenchi qui
// sotto: il resto segue da solo.
//
// La sicurezza non sta qui: canAccess decide cosa si MOSTRA, e sono le API a rispondere 403.
import zoelia from "./zoelia/app";
import accessi from "./accessi/app";
import rotteAccessi from "./accessi/routes";

// L'ordine è quello dei riquadri. "Utenti e accessi" sta in fondo: non è un'app di lavoro, è il
// governo della piattaforma.
export const apps = [zoelia, accessi];

/** Le rotte delle app, da comporre in router/routes.js con quelle di sempre. */
export function allAppRoutes() {
  return [...rotteAccessi];
}

/** Le app che questa persona vede, dalle features di /account/me. */
export function visibleApps(features) {
  return apps.filter((app) => app.canAccess(features || {}));
}

/**
 * L'app a cui appartiene un percorso. Zoelia non dichiara percorsi: è tutto quello che non sta in
 * un'altra app, e così nessuna delle sue cento rotte va elencata qui.
 */
export function appForPath(percorso) {
  const trovata = apps.find((app) => (app.match || []).some(
    (prefisso) => percorso === prefisso || percorso.startsWith(`${prefisso}/`)));
  return trovata || zoelia;
}
